import { render, staticRenderFns } from "./KycOwnerPage.vue?vue&type=template&id=440e8c0f&"
import script from "./KycOwnerPage.vue?vue&type=script&lang=js&"
export * from "./KycOwnerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports